import React from 'react';
import { Link } from 'react-router-dom';

export default class AboutFour extends React.Component {
    render() {
        let publicUrl = process.env.PUBLIC_URL + '/';
        return (
            <>
                <section className="about-three work-perfomance-one-sec">
                    <div className="container">
                        <div className="row">
                            {/* Image Side (Left) */}
                            <div className="col-xl-5">
                                <div className="about-four__img work-perfomance-one__img">
                                    <img
                                        src={publicUrl + 'assets/images/services/machinery.jpg'}
                                        alt="Marine Services"
                                        className="img-fluid rounded shadow"
                                        style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
                                    />
                                </div>
                            </div>

                            {/* Content Side (Right) */}
                            <div className="col-xl-7">
                                <div className="about-three__content">
                                    <div className="sec-title">
                                        <div className="sec-title__tagline">
                                            <h6> ABOUT US </h6> <span className="right"></span>
                                        </div>
                                        <h2 className="sec-title__title">Marine Excellence & Innovation</h2>
                                    </div>

                                    <div className="about-three__content-inner">
                                        <div className="text1">
                                            <p>
                                                We specialize in marine machinery, navigation systems,
                                                ship automation, and safety solutions — ensuring
                                                reliable and secure operations for vessels worldwide.
                                            </p>
                                        </div>
                                        <div className="text2">
                                            <h4>Delivering trust, technology, and safety at sea.</h4>
                                        </div>
                                        <ul className="about-three__content-list">
                                            <li>
                                                <div className="icon-box">
                                                    <span className="icon-tick"></span>
                                                </div>
                                                <div className="text-box">
                                                    <p> Ship Machinery & Engine Supply</p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon-box">
                                                    <span className="icon-tick"></span>
                                                </div>
                                                <div className="text-box">
                                                    <p> Advanced Navigation & GPS Systems</p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon-box">
                                                    <span className="icon-tick"></span>
                                                </div>
                                                <div className="text-box">
                                                    <p> Automation & Safety Equipment</p>
                                                </div>
                                            </li>
                                        </ul>
                                        <div className="about-three__content-btn">
                                            <Link
                                                to={`${process.env.PUBLIC_URL}/about-one`}
                                                className="thm-btn"
                                                data-text="Discover More +"
                                            >
                                                Discover More +
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}
